import axios from '@/utils/axios';

export default {
  getSetting(settingId) {
    return axios.get(`/user/setting?setting_id=${settingId}`);
  },
  updateSetting(settingId, data) {
    return axios.post(`/user/setting?setting_id=${settingId}`, data);
  }
}
